export const copyrightMessage = `
  © Robot Vision & Learning (RVL) Lab. All rights reserved. 
`
